import * as React from 'react'

import { PauseIcon, PlayIcon, SpeakerIcon, StopIcon } from './speechIcons'

import { isTextToSpeechSupported } from '../../libs/speech/speechManager'
import { Tooltip } from '../shared/tooltip'

const STOP_LABEL = 'Stop reading aloud'
const PAUSE_LABEL = 'Pause reading aloud'
const RESUME_LABEL = 'Resume reading aloud'

interface ReadAloudSpeakerToggleProps {
  ariaControls?: string;
  className?: string;
  focusOnDark?: boolean;
  label: string;
  onPause?: () => void;
  onPlay: () => void;
  onStop?: () => void;
  paused?: boolean;
  playIcon?: boolean;
  playing: boolean;
  tooltipText?: string;
}

const ReadAloudSpeakerToggle = ({ ariaControls, className, focusOnDark, label, onPause, onPlay, onStop, paused = false, playIcon = false, playing, tooltipText, }: ReadAloudSpeakerToggleProps) => {
  if (!isTextToSpeechSupported()) { return null }

  const active = playing || paused
  const classes = ['read-aloud-button', 'interactive-wrapper', focusOnDark ? 'focus-on-dark' : 'focus-on-light', active ? 'is-playing' : '', className || ''].filter(Boolean).join(' ')

  let state = { handleClick: onPlay, icon: playIcon ? <PlayIcon /> : <SpeakerIcon />, label, }
  if (playing && onPause) {
    state = { handleClick: onPause, icon: <PauseIcon />, label: PAUSE_LABEL, }
  } else if (playing) {
    state = { handleClick: onStop, icon: <StopIcon />, label: STOP_LABEL, }
  } else if (paused) {
    state = { handleClick: onPlay, icon: <PlayIcon />, label: RESUME_LABEL, }
  }

  const button = (
    <button
      aria-controls={ariaControls}
      aria-label={state.label}
      aria-pressed={active}
      className={classes}
      onClick={state.handleClick}
      type="button"
    >
      {state.icon}
    </button>
  )

  return tooltipText ? <Tooltip isTabbable={false} tooltipText={tooltipText} tooltipTriggerText={button} /> : button
}

export { ReadAloudSpeakerToggle }
